/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Where this carrier stands on this opportunity. "none" means they have
 * not registered interest; "interested" is a draft agreement created by
 * the carrier clicking Mark Interested, before FreightSimple has asked
 * them for pricing.
 *
 * @export
 */
export const OpportunityAgreementStatus = {
  None: "none",
  Interested: "interested",
  AwaitingPricing: "awaiting_pricing",
  BeingSetUp: "being_set_up",
  Active: "active",
  Declined: "declined",
  Cancelled: "cancelled",
  ExistingCustomer: "existing_customer",
} as const;
export type OpportunityAgreementStatus =
  (typeof OpportunityAgreementStatus)[keyof typeof OpportunityAgreementStatus];

export function instanceOfOpportunityAgreementStatus(value: any): boolean {
  for (const key in OpportunityAgreementStatus) {
    if (Object.prototype.hasOwnProperty.call(OpportunityAgreementStatus, key)) {
      if (
        OpportunityAgreementStatus[
          key as keyof typeof OpportunityAgreementStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OpportunityAgreementStatusFromJSON(
  json: any,
): OpportunityAgreementStatus {
  return OpportunityAgreementStatusFromJSONTyped(json, false);
}

export function OpportunityAgreementStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityAgreementStatus {
  return json as OpportunityAgreementStatus;
}

export function OpportunityAgreementStatusToJSON(
  value?: OpportunityAgreementStatus | null,
): any {
  return value as any;
}

export function OpportunityAgreementStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OpportunityAgreementStatus {
  return value as OpportunityAgreementStatus;
}
